import { render, staticRenderFns } from "./tag-watch-form-dialog.app.vue?vue&type=template&id=65e4ed39&"
import script from "./tag-watch-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./tag-watch-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports